import { useAppDispatch } from "../../store/hooks";
import { setIDs } from "../../store/market/marketSlice";
import { idType } from "../../store/market/types";
import { HistDataResp, MarketResp } from "../types/MarketResp";

export const useMarket = () => {
    const dispatch = useAppDispatch();
  return {
    //gets prices at daily level, every 5 min increments
    //use for latest price and for daily charts
    getPrice: async (token: string, zoom: string, date?: string) => {
      const now = new Date().toLocaleDateString("en-GB").split("/").join("-");
      let anyDate = "";
      let then;
      if (date) {
        then = new Date(date)
          .toLocaleDateString("en-GB")
          .split("/")
          .join("-");
        anyDate = `https://api.coingecko.com/api/v3/coins/${token}/history?date=${then}`;
      }

      const oneWeek = `https://api.coingecko.com/api/v3/coins/${token}/market_chart?vs_currency=usd&days=7&interval=daily`;
      const oneMonth = `https://api.coingecko.com/api/v3/coins/${token}/market_chart?vs_currency=usd&days=30&interval=daily`;
      //const oneDay = `https://api.coingecko.com/api/v3/coins/${token}/ohlc?vs_currency=usd&days=1`
      const oneDay = `https://api.coingecko.com/api/v3/coins/${token}/market_chart?vs_currency=usd&days=1`;

      let URL = "";
      if (zoom == "day") {
        URL = oneDay;
      } else if (zoom == "week") {
        URL = oneWeek;
      } else if (zoom == "month") {
        URL = oneMonth;
      } else if (date && zoom == "half-year" || zoom == "year") {
        URL = anyDate;
      }
      let res = {} as HistDataResp;
      await fetch(URL)
        .then((res) => {
          return res.json();
        })
        .then((resData) => {
          if (resData.errors) {
            console.log(resData);
            throw new Error("Fetching price failed");
          }
          if(zoom == "half-year" || zoom == "year") {
            res = resData.market_data.current_price.usd
          } else {
            res = resData.prices;
          }
          
          //console.log(resData);
        });
      return res;
    },

    getChart: async () => {},

    // getIDs: async () => {
    //     let res = [] as idType[];
    //   await fetch('https://api.coingecko.com/api/v3/coins/list?include-platform=true')
    //     .then((res) => {
    //       return res.json();
    //     })
    //     .then((resData) => {
    //       if (resData.errors) {
    //         console.log(resData);
    //         throw new Error("Fetching price failed");
    //       }

    //         res = resData;

          
    //       //console.log(resData);
    //     });
    //     dispatch(setIDs(res));
    //   return res;
    // }
  };
};
